import { Skeleton } from 'antd';
import { selectors, useManageProjectCommentsMutation } from 'app/services/projects';
import { Drawers } from 'app/types/drawer';
import { DataForm, FieldProps, FieldType } from 'components';
import { useSelector } from 'react-redux';

const ManageComments = () => {
  const data = useSelector(selectors.getProject);

  const [ manageComments, meta ] = useManageProjectCommentsMutation();

  const fields: FieldProps[] = [
    { name: 'QuantitiesComments', type: FieldType.TEXTAREA, max: 1024 },
    { name: 'CloseNotes', type: FieldType.TEXTAREA, max: 1024 },
    { name: 'OtherComments', type: FieldType.TEXTAREA, max: 1024 },
    { name: 'SafetyComments', type: FieldType.TEXTAREA, max: 1024 },
  ];

  if (!data) return <Skeleton active />;

  const handleSubmit = async (values: any) => await manageComments({
    comments: {
      QuantitiesComments: values.QuantitiesComments,
      OtherComments: values.OtherComments,
      SafetyComments: values.SafetyComments,
      CloseNotes: values.CloseNotes
    },
    projectId: data.Id
  });

  return (
    <DataForm
      id={Drawers.MANAGE_PROJECT_COMMENTS}
      entity="project"
      onSubmit={handleSubmit}
      fields={fields}
      initialValues={data}
      meta={meta} />
  );
};

export default ManageComments;